import './gallery-block.scss';
import 'magnific-popup';

export default () => {
	const galleryBlock = document.querySelector( '.gallery-block__holder' );

	if ( galleryBlock ) {
		$( galleryBlock ).magnificPopup( {
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true, // Enable gallery mode
				navigateByImgClick: true,
				preload: [
					0,
					1,
				], // Preload previous and next images
			},
		} );
	}
};
